import PropTypes from 'prop-types'
import { MediaPreview } from "ui/MediaPreview"
import { PreviewGallery } from "ui/PersonalInfo/ProfilePreview/PreviewGallery"

export default function PhotoGrid({ photos = [], handleMediaClick, guideName = "" }) {
  if (!photos.length) return null

  const renderMedia = (media, idx) => (
    <MediaPreview
      key={media?.id || idx}
      media={media}
      src={media.url}
      alt=""
      className="object-fit-cover w-100 h-100 rounded"
      wrapperClassName="w-100 h-100"
      effect="blur"
      placeholderSrc={media.placeholder_url || null}
      onClick={() => handleMediaClick?.(media)}
    />
  )

  if (photos.length === 1) {
    return (
      <div className="grid gap-2 mt-15">
        <div className="g-col-12 g-col-lg-12">{renderMedia(photos[0], 0)}</div>
      </div>
    )
  }

  if (photos.length === 2) {
    return (
      <div className="grid gap-2 mt-15">
        {[0, 1].map((i) => (
          <div key={i} className="g-col-12 g-col-md-12 g-col-lg-6" style={{ maxHeight: 420 }}>
            {renderMedia(photos[i], i)}
          </div>
        ))}
      </div>
    )
  }

  if (photos.length === 3) {
    return (
      <div className="grid gap-2 mt-15">
        <div className="g-col-12 g-col-lg-6" style={{ maxHeight: 560 }}>
          {renderMedia(photos[0], 0)}
        </div>
        <div className="g-col-12 g-col-lg-6 grid grid-cols-6 gap-2">
          <div className="g-col-6 grid grid-cols-1 grid-rows-8 gap-2" style={{ maxHeight: 560 }}>
            <div className="g-row-4">{renderMedia(photos[1], 1)}</div>
            <div className="g-row-4">{renderMedia(photos[2], 2)}</div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="grid gap-2 mt-15">
      <div className="g-col-12 g-col-lg-6" style={{ maxHeight: 560 }}>
        {renderMedia(photos[0], 0)}
      </div>
      <div className="g-col-12 g-col-lg-6 grid grid-cols-6 gap-2">
        <div className="g-col-6 grid grid-cols-1 grid-rows-8 gap-2" style={{ maxHeight: 560 }}>
          <div className="g-row-4">{renderMedia(photos[1], 1)}</div>
          <div className="g-row-4 position-relative">
            <div className="position-absolute bottom-0 end-0 p-3 z-2">
              <PreviewGallery name={guideName} mediaItems={photos} hideGrid />
            </div>
            {renderMedia(photos[2], 2)}
          </div>
        </div>
      </div>
    </div>
  )
}

// ✅ PropTypes validation
PhotoGrid.propTypes = {
  photos: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      url: PropTypes.string.isRequired,
      placeholder_url: PropTypes.string,
    })
  ),
  handleMediaClick: PropTypes.func,
  guideName: PropTypes.string,
}
